import { ROTA } from '@/dominio/Rota';
import { inject, observer } from 'mobx-react';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import ComposicaoEmLote from './ComposicaoEmLote';
import ConfirmarPublicarPautaLote from './ConfirmarPublicarPautaLote';
import ExportarProcessosParaArquivoCsvPauta from './ExportarProcessosParaArquivoCsvPauta';
import FiltroRapido from './FiltroRapido';
import IncluirProcessosPautaLote from './IncluirProcessosPautaLote';
import RemoverProcessosPautaLote from './RemoverProcessosPautaLote';
import TipoJulgamentoLote from './TipoJulgamentoLote';
import RepublicarPautaLote from './RepublicarPautaLote';
import CancelarDisponibilizacaoPautaLote from './CancelarDisponibilizacaoPautaLote';
import IntimarPautaLote from './IntimarPautaLote';
import PublicarCancelamentoPautaLote from './PublicarEditalCancelamentoPautaLote';

class FerramentasListaProcessosPauta extends ReactComponent {
    render() {
        return (
            <div
                id="divFerramentasListaProcessos"
                style={{ display: 'flex', margin: '0px 10px', justifyContent: 'space-between', alignItems: 'center' }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexGrow: '1',
                        justifyContent: 'space-between',
                        marginTop: '5px',
                        zIndex: '999'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexGrow: '1',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            flexWrap: 'wrap',
                            margin: '5px',
                            marginLeft: '10px'
                        }}
                    >
                        {this.pautaJulgamentoStore.idProcessosEmExibicao === 'A' && (
                            <div className="corBotao">
                                <IncluirProcessosPautaLote />
                            </div>
                        )}
                        {this.pautaJulgamentoStore.idProcessosEmExibicao === 'P' && (
                            <>
                                <div className="corBotao">
                                    <RemoverProcessosPautaLote />
                                </div>
                                <div className="corBotao">
                                    <ConfirmarPublicarPautaLote />
                                </div>
                                <div className="corBotao">
                                    <RepublicarPautaLote />
                                </div>
                                <div className="corBotao">
                                    <CancelarDisponibilizacaoPautaLote />
                                </div>
                                <div className="corBotao">
                                    <PublicarCancelamentoPautaLote />
                                </div>

                                <div className="corBotao">
                                    <IntimarPautaLote />
                                </div>
                                <div className="corBotao">
                                    <ComposicaoEmLote pagina={ROTA.PAUTA.id} />
                                </div>
                                <div>
                                    <TipoJulgamentoLote />
                                </div>
                            </>
                        )}
                        <ExportarProcessosParaArquivoCsvPauta />
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                            <PainelFiltros />
                        </div>
                    </div>
                    <FiltroRapido id="filtroRapidoListaProcessosPauta" />
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(FerramentasListaProcessosPauta));
